import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var quizTimerRes;
export const quizTimerTodo = createAsyncThunk('quizTimer', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/get_quiz_timer',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "time": val.time,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return quizTimerRes = res.data
    } catch (error) {
        return quizTimerRes = error.response.data
    }
})


const quizTimerSlice = createSlice({
    name: 'quizTimer',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(quizTimerTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('quizTimer', state.data)
            }
        });
        builder.addCase(quizTimerTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default quizTimerSlice.reducer; 